import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const LevelBadge = ({ level = 1, onClick }) => {
  const { t } = useTranslation();
  const getBadgeClass = (lvl) => {
    if (lvl >= 50) return 'level-badge-legendary';
    if (lvl >= 40) return 'level-badge-expert';
    if (lvl >= 30) return 'level-badge-veteran';
    if (lvl >= 20) return 'level-badge-advanced';
    if (lvl >= 10) return 'level-badge-intermediate';
    return 'level-badge-beginner';
  };

  return (
    <button
      className={`level-badge ${getBadgeClass(level)}`}
      onClick={onClick}
      title={t('level_badge_tooltip', { level })}
    >
      <span className="level-text">{t('lvl')}</span>
      <span className="level-number">{level}</span>
    </button>
  );
};

export default memo(LevelBadge);
